document.addEventListener("DOMContentLoaded", function () {
  const sentinel = document.getElementById("infinite-scroll-sentinel");
  if (!sentinel) return;

  let loading = false;

  // Nächste Seite aus dem paginate-Block holen
  let nextPageUrl = document.querySelector('#component-pagination-loader a')?.href;

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && nextPageUrl && !loading) {
      loading = true;

      fetch(nextPageUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          // Neue Produkte aus der nächsten Seite holen
          const newProducts = doc.querySelectorAll("#data-pagination .grid__item");
          const productGrid = document.querySelector("#data-pagination");

          newProducts.forEach(item => productGrid.appendChild(item));

          // Neue URL für die nächste Seite
          const newNext = doc.querySelector("#component-pagination-loader a")?.href;
          nextPageUrl = newNext || null;

          loading = false;
        })
        .catch(err => {
          console.error("Infinite Scroll Fehler:", err);
          loading = false;
        });
    }
  }, { rootMargin: "200px" });

  observer.observe(sentinel);
});